'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OfficeHoursMessageMetadata = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.OFFICE_HOURS), _defineProperty(_Record, 'text', ''), _defineProperty(_Record, 'officeHoursStartTime', null), _Record), 'OfficeHoursMessageMetadata');

exports.default = OfficeHoursMessageMetadata;
module.exports = exports['default'];